import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TenantOnboardingWizard } from "@/components/tenants/TenantOnboardingWizard";
import { TenantFormData } from "@/types/tenant";
import { useTenants } from "@/hooks/useTenants";

export default function OnboardTenantPage() {
  const navigate = useNavigate();
  const { createTenant, isCreating } = useTenants();

  const handleComplete = async (data: TenantFormData) => {
    await createTenant(data);
    navigate("/admin/tenants");
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" onClick={() => navigate("/admin/tenants")}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <div>
          <h1 className="text-2xl font-bold text-foreground">Onboard New Customer</h1>
          <p className="text-muted-foreground mt-1">
            Add a new customer tenant to your partner account
          </p>
        </div>
      </div>

      {/* Wizard */}
      <TenantOnboardingWizard 
        onComplete={handleComplete}
        isSubmitting={isCreating}
      />
    </div>
  );
}
